import Image from "next/image";
import CTAButtonLink from "../cta/CTAButtonLink";
import { RecursiveTranslations } from "@/data/types";
import { ArrowRightIcon } from "@/components/icons";

interface DeveloperCardProps {
  translations: RecursiveTranslations;
  logo: string;
  brochure_url?: string;
}

export default function DeveloperCard({ translations, logo, brochure_url }: DeveloperCardProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 min-w-[260px] h-[280px] sm:min-w-[324px] sm:h-[323px] p-6 rounded-[4px] border border-gray-200 bg-[#faf9f7] shadow-sm hover:shadow-md transition duration-300">
      <div className="flex items-center justify-center w-[170px] h-[70px]">
        <Image src={logo} alt="Developer Logo" width={120} height={70} className="object-contain" style={{ width: 'auto', height: '100%' }} />
      </div>

      {brochure_url && (
        <CTAButtonLink
          href={brochure_url}
          className="!px-[15px] !text-[12px]"
          size="small"
          target="_blank"
          rel="noopener noreferrer"
          rightIcon={<ArrowRightIcon color="white" width={15} height={15} />}
        >
          {translations?.buttonLabel as string}
        </CTAButtonLink>
      )}
    </div>
  );
}
